module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "dedication",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "ded1"
  }, [_c('span', {
    attrs: {
      "aria-label": "v",
      "epub:type": "pagebreak",
      "id": "page_v",
      "role": "doc-pagebreak",
      "title": "v"
    }
  }, [_vm._v("For my father, K. David Styles.")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("It wasn’t until I wrote the last word of this book that I realized it may actually be a love letter to you. Thank you for the day you told me to “go seek God” with your full blessing—even if my wandering led me out and away from your familiar paths. You were never afraid for me to go, and so I was never afraid of the wilderness. Your love has been our shelter and our home.")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Thank you for a lifetime of ordinary miracles.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-799c51f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781501155475/xhtml/dedication.vue
// module id = 69
// module chunks = 0